module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-right-down-6b780090ec91496eb82d338d41543b72.svg";